import { HistoryRecord, VersionHistory } from './types';

export class InMemoryCache<T> implements VersionHistory<T> {
  private cache: HistoryRecord<T>[] = [];
  private lastVersionIndex: number = 0;
  private readonly cacheLimit: number;

  constructor(cacheLimit: number) {
    this.cacheLimit = cacheLimit;
  }

  getVersion(index: number): T | null {
    return (
      this.cache.find(({ index: verIndex }) => verIndex === index)?.data ?? null
    );
  }

  pushVersion(data: T): number {
    this.lastVersionIndex += 1;
    this.cache.push({ data, index: this.lastVersionIndex });

    if (this.cache.length > this.cacheLimit) {
      this.cache.shift();
    }

    return this.lastVersionIndex;
  }

  getLastVersionIndex(): number {
    return this.lastVersionIndex;
  }

  getAvailableVersionIndexes(): number[] {
    return this.cache.map(({ index }) => index);
  }
}
